import React from "react";
import { Link } from "react-router-dom";

const CompanyFour = () => {
    return (
        <div className="container position-relative">
            <div className="row g-4" data-aos="fade-up">
                <div className="col-12">
                    <div className="card border-0 shadow-lg overflow-hidden" 
                        style={{ 
                            background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
                        }}>
                        <div className="card-body p-4 p-lg-5">
                            <div className="row align-items-center">
                                <div className="col-lg-8">
                                    <h3 className="fw-bold mb-3" style={{ color: '#1a237e' }}>
                                        Why Join <span style={{ color: '#ff2222' }}>Agency Bazaar</span> — India's Leading Career in Insurance Platform?
                                    </h3>

                                    <div className="row g-3 mt-4">
                                        <div className="col-md-6">
                                            <div className="d-flex align-items-start gap-2 p-3 rounded-4 transition-all duration-300"
                                                style={{ cursor: 'pointer', backgroundColor: 'rgba(255, 255, 255, 0.6)' }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(-5px)';
                                                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.95)';
                                                    e.currentTarget.style.boxShadow = '0 10px 30px rgba(255, 34, 34, 0.15)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(0)';
                                                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.6)';
                                                    e.currentTarget.style.boxShadow = 'none';
                                                }}>
                                                <div className="rounded p-2" style={{ backgroundColor: 'rgba(255, 34, 34, 0.15)' }}>
                                                    <i className="bi bi-building-fill fs-5" style={{ color: '#ff2222' }}></i>
                                                </div>
                                                <div>
                                                    <h6 className="fw-bold mb-1" style={{ color: '#ff2222' }}>10+ Top Insurers</h6>
                                                    <p className="small mb-0" style={{ color: '#37474f' }}>Sell from Niva Bupa, Care Health, Star, Tata AIG & more — all platforms</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="d-flex align-items-start gap-2 p-3 rounded-4 transition-all duration-300"
                                                style={{ cursor: 'pointer', backgroundColor: 'rgba(255, 255, 255, 0.6)' }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(-5px)';
                                                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.95)';
                                                    e.currentTarget.style.boxShadow = '0 10px 30px rgba(255, 34, 34, 0.15)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(0)';
                                                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.6)';
                                                    e.currentTarget.style.boxShadow = 'none';
                                                }}>
                                                <div className="rounded p-2" style={{ backgroundColor: 'rgba(255, 34, 34, 0.15)' }}>
                                                    <i className="bi bi-graph-up-arrow fs-5" style={{ color: '#ff2222' }}></i>
                                                </div>
                                                <div>
                                                    <h6 className="fw-bold mb-1" style={{ color: '#ff2222' }}>Lifetime Renewals</h6>
                                                    <p className="small mb-0" style={{ color: '#37474f' }}>Earn passive income year after year on every policy sold</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="d-flex align-items-start gap-2 p-3 rounded-4 transition-all duration-300"
                                                style={{ cursor: 'pointer', backgroundColor: 'rgba(255, 255, 255, 0.6)' }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(-5px)';
                                                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.95)';
                                                    e.currentTarget.style.boxShadow = '0 10px 30px rgba(255, 34, 34, 0.15)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(0)';
                                                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.6)';
                                                    e.currentTarget.style.boxShadow = 'none';
                                                }}>
                                                <div className="rounded p-2" style={{ backgroundColor: 'rgba(255, 34, 34, 0.15)' }}>
                                                    <i className="bi bi-mortarboard-fill fs-5" style={{ color: '#ff2222' }}></i>
                                                </div>
                                                <div>
                                                    <h6 className="fw-bold mb-1" style={{ color: '#ff2222' }}>Free Training & Certification</h6>
                                                    <p className="small mb-0" style={{ color: '#37474f' }}>Complete IRDAI training provided, no prior experience needed</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="d-flex align-items-start gap-2 p-3 rounded-4 transition-all duration-300"
                                                style={{ cursor: 'pointer', backgroundColor: 'rgba(255, 255, 255, 0.6)' }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(-5px)';
                                                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.95)';
                                                    e.currentTarget.style.boxShadow = '0 10px 30px rgba(255, 34, 34, 0.15)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(0)';
                                                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.6)';
                                                    e.currentTarget.style.boxShadow = 'none';
                                                }}>
                                                <div className="rounded p-2" style={{ backgroundColor: 'rgba(255, 34, 34, 0.15)' }}>
                                                    <i className="bi bi-people-fill fs-5" style={{ color: '#ff2222' }}></i>
                                                </div>
                                                <div>
                                                    <h6 className="fw-bold mb-1" style={{ color: '#ff2222' }}>5000+ Strong Community</h6>
                                                    <p className="small mb-0" style={{ color: '#37474f' }}>Join a network of successful retired officers & women agents</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 text-center mt-4 mt-lg-0">
                                    <div className="rounded-4 p-4" style={{ 
                                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                        backdropFilter: 'blur(10px)',
                                        border: '1px solid rgba(255, 255, 255, 0.9)'
                                    }}>
                                        <div className="d-grid gap-2">
                                            <Link to="/Contactus" className="btn btn-lg rounded-pill fw-bold shadow hover-scale transition-all duration-300"
                                                style={{ backgroundColor: '#ff2222', borderColor: '#ff2222', color: 'white' }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(-3px)';
                                                    e.currentTarget.style.boxShadow = '0 15px 30px rgba(255, 34, 34, 0.4)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(0)';
                                                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.2)';
                                                }}>
                                                Start Your Journey Today <i className="bi bi-arrow-right ms-2"></i>
                                            </Link>
                                            <a href="tel:+917715879666" className="btn rounded-pill fw-semibold transition-all duration-300"
                                                style={{ 
                                                    borderColor: '#1a237e', 
                                                    color: '#1a237e',
                                                    border: '2px solid #1a237e'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(-3px)';
                                                    e.currentTarget.style.boxShadow = '0 15px 30px rgba(26, 35, 126, 0.2)';
                                                    e.currentTarget.style.backgroundColor = '#1a237e';
                                                    e.currentTarget.style.color = 'white';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(0)';
                                                    e.currentTarget.style.boxShadow = 'none';
                                                    e.currentTarget.style.backgroundColor = 'transparent';
                                                    e.currentTarget.style.color = '#1a237e';
                                                }}>
                                                <i className="bi bi-telephone-fill me-2"></i>Talk to Our Mentor
                                            </a>
                                        </div>
                                        <p className="small mt-3 mb-0" style={{ color: '#546e7a' }}>Only 18+ age & 12th Pass required</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* <div className="row g-4 mt-5 text-center" data-aos="fade-up">
                <div className="col-6 col-md-3">
                    <div className="bg-white rounded-4 p-4 shadow-sm transition-all duration-300"
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-8px)';
                            e.currentTarget.style.boxShadow = '0 15px 30px rgba(0, 0, 0, 0.15)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.08)';
                        }}>
                        <div className="display-5 fw-bold text-primary mb-1">5000+</div>
                        <p className="text-muted mb-0">Successful Agents</p>
                    </div>
                </div>
                <div className="col-6 col-md-3">
                    <div className="bg-white rounded-4 p-4 shadow-sm transition-all duration-300"
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-8px)';
                            e.currentTarget.style.boxShadow = '0 15px 30px rgba(0, 0, 0, 0.15)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.08)';
                        }}>
                        <div className="display-5 fw-bold text-success mb-1">40%</div>
                        <p className="text-muted mb-0">Women Agents</p>
                    </div>
                </div>
                <div className="col-6 col-md-3">
                    <div className="bg-white rounded-4 p-4 shadow-sm transition-all duration-300"
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-8px)';
                            e.currentTarget.style.boxShadow = '0 15px 30px rgba(0, 0, 0, 0.15)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.08)';
                        }}>
                        <div className="display-5 fw-bold mb-1" style={{ color: '#ff2222' }}>1500+</div>
                        <p className="text-muted mb-0">Retired Officers</p>
                    </div>
                </div>
                <div className="col-6 col-md-3">
                    <div className="bg-white rounded-4 p-4 shadow-sm transition-all duration-300"
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-8px)';
                            e.currentTarget.style.boxShadow = '0 15px 30px rgba(0, 0, 0, 0.15)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.08)';
                        }}>
                        <div className="display-5 fw-bold text-danger mb-1">₹2L+</div>
                        <p className="text-muted mb-0">Avg. Monthly Income</p>
                    </div>
                </div>
            </div> */}
        </div>
    );
};

export default CompanyFour;


